import { render, staticRenderFns } from "./FelicaRegister.vue?vue&type=template&id=947d3ba4&scoped=true&"
import script from "./FelicaRegister.vue?vue&type=script&lang=js&"
export * from "./FelicaRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947d3ba4",
  null
  
)

export default component.exports